import { useEffect } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, FormLabel, Stack, TextField, Button } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Add } from "@mui/icons-material";
import PageTitle from "../../common/PageTitle";
import debounceHandler from "../../helpers/utils/debounceHandler";
import { COMPANY_STATUS_LIST } from "../../helpers/constant/coreConstant";
import { selectCompanyListState } from "../../state/companyList/companyListSelector";
import { updateCompanyListFilters } from "../../state/companyList/companyListSlice";
import useBoolean from "../../hooks/useBoolean";
import BasicDrawer from "../../global/Drawer/BasicDrawer";
import AddCompanyForm from "./AddCompanyForm";

const AllOptionObj = { "": { value: "", label: "All" } };

const CompaniesHeader = () => {
  const dispatch = useDispatch();
  const companyStatusOptions = { ...AllOptionObj, ...COMPANY_STATUS_LIST };
  const { filters } = useSelector(selectCompanyListState);
  const { ownerEmail, companyName } = filters || {};
  const { value: openDrawer, setTrue: onOpenDrawer, setFalse: onCloseDrawer } = useBoolean(false);

  const handleOwnerEmailSearch = debounceHandler((e) => {
    const { value } = e.target || {};
    dispatch(updateCompanyListFilters({ ownerEmail: value }));
  }, 1000);

  const handleCompanySearch = debounceHandler((e) => {
    const { value } = e.target || {};
    dispatch(updateCompanyListFilters({ companyName: value }));
  }, 1000);

  const handleChangeStatus = (newValue) => {
    dispatch(updateCompanyListFilters({ status: newValue.value }));
  };

  // reset filters
  useEffect(() => {
    return () => {
      dispatch(
        updateCompanyListFilters({
          ownerEmail: "",
          companyName: "",
          status: "",
        })
      );
    };
  }, []);

  return (
    <>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} mb={2}>
        <PageTitle title={"Companies"} mb={0} subTitleMb={0} />
        <Stack direction={"row"} spacing={1} alignItems={"end"}>
          <FormControl sx={{ width: 330, mb: 3, display: "none" }}>
            <FormLabel>Search By Company Owner Email:</FormLabel>
            <TextField
              size={"small"}
              type={"search"}
              placeholder={"Search By Company Owner Email"}
              sx={{ "& .MuiInputBase-root": { height: 48 } }}
              defaultValue={ownerEmail}
              onChange={handleOwnerEmailSearch}
              InputProps={{
                startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ mr: 0.5 }} />,
              }}
            />
          </FormControl>
          <FormControl sx={{ width: 300, mb: 3 }}>
            <FormLabel>Search By Company Name:</FormLabel>
            <TextField
              size={"small"}
              type={"search"}
              placeholder={"Search by company name"}
              sx={{ "& .MuiInputBase-root": { height: 48 } }}
              defaultValue={companyName}
              onChange={handleCompanySearch}
              InputProps={{
                startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ mr: 0.5 }} />,
              }}
            />
          </FormControl>
          <FormControl sx={{ width: 300, mb: 3 }}>
            <FormLabel>Filter By Company Status:</FormLabel>
            <Select
              className={"select-dropdown-menu select-dropdown-menu-custom"}
              classNamePrefix={"select-dropdown-styles"}
              isMulti={false}
              isSearchable={false}
              menuPlacement="bottom"
              options={Object.values(companyStatusOptions)}
              onChange={(newValue) => handleChangeStatus(newValue)}
            />
          </FormControl>
          <Button
            variant={"contained"}
            startIcon={<Add />}
            onClick={onOpenDrawer}
            sx={{
              height: 48,
              mb: 3,
              textTransform: "none",
              px: 3,
              fontSize: "15px",
              fontWeight: 600,
            }}
          >
            Add New Account
          </Button>
        </Stack>
      </Stack>

      <BasicDrawer title={"Add New Company Account"} open={openDrawer} onClose={onCloseDrawer} width={550}>
        <AddCompanyForm onClose={onCloseDrawer} />
      </BasicDrawer>
    </>
  );
};

export default CompaniesHeader;
